import React from 'react';
import { Checkbox } from 'antd';

export interface InlineCheckProps {
  checked: boolean;
  onToggle: (checked: boolean) => void;
  disabled?: boolean;
  ariaLabel?: string;
}

/**
 * Always-interactive boolean cell — applies INSTANTLY on change (an imperative
 * control → instant save, per the save-by-control-type rule). No edit mode, so
 * it never changes the layout.
 */
const InlineCheck: React.FC<InlineCheckProps> = ({
  checked,
  onToggle,
  disabled,
  ariaLabel,
}) => (
  <Checkbox
    checked={checked}
    disabled={disabled}
    aria-label={ariaLabel}
    onChange={e => onToggle(e.target.checked)}
  />
);

export default InlineCheck;
